import './App.css'
import { useEffect } from 'react'
import Pages from "@/pages/index"
import { Toaster } from "@/components/ui/toaster"
import ErrorBoundary from "@/components/ErrorBoundary"
import { HelmetProvider } from 'react-helmet-async'
import { captureUtmParams } from "@/utils/utm"

function App() {
  useEffect(() => {
    captureUtmParams()
  }, [])

  return (
    <HelmetProvider>
      <div className="App">
        <ErrorBoundary>
          <Pages />
          <Toaster />
        </ErrorBoundary>
      </div>
    </HelmetProvider>
  )
}

export default App
